// @owners { team: patients-team }
import { type ReduxStateShared } from '~shared/store';

export const getApplePaySupported = (state: ReduxStateShared) => {
  return state.persistedUI.applePay.isApplePaySupported || false;
};
